/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
import { deserialize, deserializeArray, serialize } from 'class-transformer';
import { Guid } from 'guid-typescript';
import { DeployedSinglePathMissionCloudState } from './enums/DeployedSinglePathMissionCloudState';
import { MachineKey } from './MachineKey';
import { ISinglePathMission, SinglePathMission } from './SinglePathMission';

export interface IDeployedSinglePathMission extends ISinglePathMission {
  MissionDeploymentID: string;
  TargetMachine: MachineKey;
  MissionState: DeployedSinglePathMissionCloudState;
  DeployerUserID: string;
  DeployedTimeUTC: Date;
  UpdateTimeUTC: Date;
  JobID: string;
  PercentageComplete: number;
  ShapefileZipS3Key: string;
}

export class DeployedSinglePathMission extends SinglePathMission implements IDeployedSinglePathMission {
  MissionDeploymentID: string;
  TargetMachine: MachineKey;
  MissionState: DeployedSinglePathMissionCloudState;
  DeployerUserID: string;
  DeployedTimeUTC: Date;
  UpdateTimeUTC: Date;
  JobID: string;
  PercentageComplete: number;
  ShapefileZipS3Key: string;

  constructor() {
    super();

    this.MissionDeploymentID = Guid.EMPTY.toString();
    this.JobID = Guid.EMPTY.toString();
    this.UpdateTimeUTC = new Date();
    this.DeployedTimeUTC = new Date();
    this.MissionState = 0;
    this.PercentageComplete = 0;
    this.DeployerUserID = '';
    this.TargetMachine = { machineId: Guid.EMPTY.toString(), AccountID: Guid.EMPTY.toString() };
    this.ShapefileZipS3Key = '';
  }

  static toModel(json: string): DeployedSinglePathMission {
    const mission = deserialize(DeployedSinglePathMission, json);
    return mission;
  }

  static toModelCollection(json: string): DeployedSinglePathMission[] {
    const missions = deserializeArray(DeployedSinglePathMission, json);
    return missions;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
